import { useMutation } from "@tanstack/react-query";
import { importWebsiteScreenshot } from "../../../api/manual-import";

export const getImportWebsiteScreenshotMutation = () => useMutation({
    mutationFn: importWebsiteScreenshot,
});